import { useEffect } from "react";

import { useLocation } from "react-router-dom";

import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";

import { getLastItem, withRouter } from "../../../shared/utility";

import { useParams } from "react-router-dom";

import CustomerGroupForm from "../../../components/forms/customerGroups/CustomerGroupForm";
import { CustomerGroupDetailsViewModel } from "../../../viewmodels/customerGroups/group/CustomerGroupDetailsViewModel";
import CustomerGroupCustomersTable from "../../../components/forms/customerGroups/CustomerGroupCustomersTable";
import EmptyModal from "../../../components/modals/EmptyModal";
import type { AppDispatch, RootState } from "../../../index";
import type { CustomerGroupFormValues } from "../../../types/customerGroups";

interface CustomerGroupDetailsProps { logout: () => void }

function CustomerGroupDetails(props: CustomerGroupDetailsProps) {
  const { logout } = props;

  let { groupId } = useParams();

  const { createGroup, updateGroup, getGroup, group, loading, emptyModal, setEmptyModelOpen } =
    CustomerGroupDetailsViewModel(logout, groupId);

  const onStartDependencides = async function () {
    // getAllergensForDropdown();
    // getUnitOfMeasuresForDropdown();
    getGroup();
  };

  useEffect(() => {
    if (groupId) {
      onStartDependencides();
    }
  }, []);

  return (
    <div className="px-4 sm:px-6 lg:px-8 space-y-4">
      <div className="card-custom">
        <CustomerGroupForm
          isEdit={Boolean(groupId)}
          group={group}
          actionCall={(values: CustomerGroupFormValues) => {
            if (groupId) {
              updateGroup(values);
            } else {
              createGroup(values);
            }
          }}
        />
      </div>
      {groupId && group ? <CustomerGroupCustomersTable customers={group.customers} /> : null}

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = (_state: RootState) => {
  return {};
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomerGroupDetails));
